import React, { useEffect } from "react";
import { useState } from "react";

const ArrowButton = ({
  type,
  label,
  disabled,
  onClick,
  styleProp,
  className,
}) => {
  const [hover, setHover] = useState();
  const [backHover, setBackHover] = useState();

  const [back, setBack] = useState("#03002F");
  const [arrow, setArrow] = useState("#fff");

  const [left, setLeft] = useState("#DDE2EB");
  const [leftArrow, setLeftArrow] = useState("#03002F");

  const toggleHover = () => {
    setHover(!hover);
  };
  const leftHover = () => {
    setBackHover(!backHover);
  };
  useEffect(() => {
    if (hover) {
      setBack("white");
      setArrow("#03002F");
    } else {
      setBack("#03002F");
      setArrow("white");
    }
  }, [hover]);
  useEffect(() => {
    if (backHover) {
      setLeft("#03002F");
      setLeftArrow("#DDE2EB");
    } else {
      setLeft("#DDE2EB");
      setLeftArrow("#03002F");
    }
  }, [backHover]);
  return (
    <button
      onClick={onClick}
      style={{ color: disabled ? "#B0AFBE" : "#03002f" }}
      className={`button_container labeled-button ${
        disabled ? "disabled_btn" : ""
      } ${className ? className : ""}`}
      onMouseEnter={type === "next" ? toggleHover : leftHover}
      onMouseLeave={type === "next" ? toggleHover : leftHover}
      tabIndex={disabled ? -1 : 0}
      aria-hidden={disabled}
    >
      {type === "next" && label}
      <span
        className="button login_btn image-wrapper"
        style={{
          background: disabled ? "#B0AFBE" : type === "next" ? back : left,
          border: disabled ? "" : type === "next" ? `1px solid ${arrow}` : "",
          ...styleProp,
        }}
        // tabIndex={disabled ? -1 : 0}
      >
        {type === "next" && (
          <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 0L9.88 8L1.88 16Z"
              fill={arrow}
            />
          </svg>
        )}
        {type === "previous" && (
          <svg
            width="10"
            height="14"
            viewBox="0 0 10 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.49974 0.332031L9.06641 1.8987L3.97752 6.9987L9.06641 12.0987L7.49974 13.6654L0.833073 6.9987L7.49974 0.332031Z"
              fill={leftArrow}
            />
          </svg>
        )}
      </span>
      {type === "previous" && label}
    </button>
  );
};

export default ArrowButton;
